import { useTheme } from "@mui/material/styles";
import { ChevronsUp } from "lucide-react";
import {
  useEffect, useState
} from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import {
  ScrollToTopButton,
  ScrollToTopButtonContent
} from "./ScrollToTopButton.styles";

export function ScrollToTop(){
  const { pathname } = useLocation();
  const theme = useTheme();
  const [isButtonVisible, setIsButtonVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    // if the browser is able to handle scroll restoration
    // on its own steal control from it :D
    const canControlScrollRestoration = "scrollRestoration" in window.history;
    if (canControlScrollRestoration) {
      window.history.scrollRestoration = "manual";
    }

    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setIsButtonVisible((window.scrollY > 0));
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      behavior: "smooth",
      top: 0
    });
  };

  return (
    <ScrollToTopButton tabIndex={ 0 } aria-label={ t("scroll_to_top") } onClick={ scrollToTop } theme={ theme } isVisible={ isButtonVisible }>
      <ScrollToTopButtonContent theme={ theme }>
        <ChevronsUp aria-hidden={ true } size={ 24 } />
      </ScrollToTopButtonContent>
    </ScrollToTopButton>
  );
}

